import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';
const getSize = (size = 'lg') => {
    const sizes = {
        sm: 64,
        lg: 106,
    };
    return sizes[size] || sizes.sm;
};
const StyledImage = styled.div `
  width: ${(props) => `${getSize(props.size)}px`};
  aspect-ratio: 1 / 1;
  background-color: ${() => 'var(--bg-color-1)'};
  border-radius: 10px;
`;
export const SkeletonImage = (props) => {
    return (React.createElement("div", { "data-role": "skeleton-image", className: cx('skeleton-image', props.className) },
        React.createElement(StyledImage, { size: props.size })));
};
